import { BehaviorSubject, Observable, ReplaySubject, Subject } from 'rxjs'
import { distinctUntilChanged, shareReplay, switchMap, take, tap } from 'rxjs/operators'
import { IBaseLoader } from './base-loader'
import { ILoaderControl } from './models/loader-control'


export class LoaderControl<T> implements ILoaderControl<T> {
  private readonly dataName$: ReplaySubject<string> = new ReplaySubject<string>(1)
  public readonly dataLoaded$: Observable<boolean> = new BehaviorSubject(false)
  public readonly data$: Observable<T> = this.dataName$.pipe(
    distinctUntilChanged(),
    tap(() => (this.dataLoaded$ as Subject<boolean>).next(false)),
    switchMap(modelName => this.loader.load<T>(modelName).pipe(
      tap(() => (this.dataLoaded$ as Subject<boolean>).next(true)),
      shareReplay(1)
    ))
  )

  constructor(private readonly loader: IBaseLoader, dataName?: string) {
    if (dataName) {
      this.dataName$.next(dataName)
      this.data$.pipe(take(1)).subscribe()
    }
  }

  public load(dataName: string): void {
    this.dataName$.next(dataName)
  }

  public preload(preLoads: string[]): void {
    this.loader.startPreload(preLoads)
  }
}
